module.exports = __webpack_public_path__ + "img/d0eb03b.jpg";